import React from "react";
import {useTranslation} from "react-i18next";

export const Header = () => {
  const { t } = useTranslation();

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  <span>
                     {t('header.titleOne')}
                  </span>
                  <span>
                     {t('header.titleTwo')}
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
